/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { Card, CardContent } from "../../../components/ui/card";
import { Accordion } from "../../../components/ui/accordion";
import CartAccordionItem1 from "./CartAccordionItem1";
import CartAccordionItem2 from "./CartAccordionItem2";
import CartAccordionItem3 from "./CartAccordionItem3";
import CartAccordionItem4 from "./CartAccordionItem4";
import CartAccordionItem5 from "./CartAccordionItem5";
import { useTranslation } from "react-i18next";
import ErrorBoundary from "../../../ErrorBoundary";

export default function CartCustomerDetails({
  cartList,
  id,
  authToken,
  handleCartList,
  orderingMethod,
  restaurantDetail,
  setOrderingMethod,
  isDineIn,
  selectedType,
  setSelectedType,
  ssoUserDetails,
  ssoAddress,
  handleSSOAddress,
}) {
  const [isLoading, setIsLoading] = React.useState<boolean>(false);

  const { t } = useTranslation();
  const [openItem, setOpenItem] = React.useState<any>("item-1");
  const handleAccordionClick = (itemValue) => {
    setOpenItem(openItem === itemValue ? null : itemValue);
  };
  return (
    <ErrorBoundary>
      <Accordion
        type="single"
        collapsible
        className="w-full space-y-4"
        value={openItem}
        onValueChange={handleAccordionClick}
      >
        <CartAccordionItem1
          authToken={authToken}
          cartList={cartList}
          handleAccordionClick={handleAccordionClick}
          handleCartList={handleCartList}
          id={id}
          isLoading={isLoading}
          setIsLoading={setIsLoading}
          ssoUserDetails={ssoUserDetails}
        />

        <CartAccordionItem2
          authToken={authToken}
          cartList={cartList}
          handleAccordionClick={handleAccordionClick}
          handleCartList={handleCartList}
          id={id}
          isLoading={isLoading}
          orderingMethod={orderingMethod}
          restaurantDetail={restaurantDetail}
          setIsLoading={setIsLoading}
          setOrderingMethod={setOrderingMethod}
          isDineIn={isDineIn}
          selectedType={selectedType}
          setSelectedType={setSelectedType}
          ssoAddress={ssoAddress}
          handleSSOAddress={handleSSOAddress}
          ssoUserDetails={ssoUserDetails}
        />
        <CartAccordionItem3
          authToken={authToken}
          cartList={cartList}
          handleAccordionClick={handleAccordionClick}
          handleCartList={handleCartList}
          id={id}
          orderingMethod={orderingMethod}
          restaurantDetail={restaurantDetail}
        />
        <CartAccordionItem4
          authToken={authToken}
          cartList={cartList}
          handleAccordionClick={handleAccordionClick}
          handleCartList={handleCartList}
          id={id}
          orderingMethod={orderingMethod}
          restaurantDetail={restaurantDetail}
        />
        <CartAccordionItem5
          authToken={authToken}
          cartList={cartList}
          handleAccordionClick={handleAccordionClick}
          handleCartList={handleCartList}
          id={id}
          restaurantDetail={restaurantDetail}
        />
      </Accordion>
    </ErrorBoundary>
  );
}
